import React from "react";

/**
 * ProtectedEmail — the studio address is assembled in the browser from
 * fragments, so it never appears as plain text in the served HTML source.
 * Without JavaScript, the <noscript> fallback shows the obfuscated form.
 */
const ProtectedEmail = ({ className = "", testId }) => {
  const [addr] = React.useState(() => ["private", "ordorexstudio.com"].join("@"));
  return (
    <>
      <a href={`mailto:${addr}`} data-testid={testId} className={className}>
        {addr}
      </a>
      <noscript>private [at] ordorexstudio.com</noscript>
    </>
  );
};

export default ProtectedEmail;
